const STORAGE_KEY = 'gary-strategy:siteName';
export const DEFAULT_SITE_NAME = 'John Strategy Club';

export function parseSiteName(name) {
  if (!name || !String(name).trim()) {
    return { title: '', subtitle: '', full: '' };
  }

  const raw = String(name).trim();
  const parts = raw.split(/[\n\r]+/).filter((p) => p.trim());

  if (parts.length >= 2) {
    return { title: parts[0].trim(), subtitle: parts[1].trim(), full: raw };
  }

  if (raw.includes(' ')) {
    const words = raw.trim().split(' ');
    if (words.length >= 2) {
      const subtitle = words.pop();
      return {
        title: words.join(' ').toUpperCase(),
        subtitle: subtitle.toUpperCase(),
        full: raw,
      };
    }
  }

  return { title: raw.toUpperCase(), subtitle: '', full: raw };
}

export function getCachedSiteName() {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function saveSiteName(name) {
  const parsed = parseSiteName(name);
  if (!parsed.full) return parsed;

  try {
    localStorage.setItem(STORAGE_KEY, parsed.full);
  } catch {
    // ignore quota / private mode
  }

  if (typeof document !== 'undefined') {
    document.title = parsed.full;
  }

  return parsed;
}

export function getInitialSiteNameDisplay() {
  return parseSiteName(getCachedSiteName() || DEFAULT_SITE_NAME);
}
